import React from 'react';
import { motion } from 'framer-motion';
import { FiStar, FiMapPin, FiCheck, FiNavigation } from 'react-icons/fi';

export default function SmallSearchPro({ data, color }) {
    // 🛡️ BLINDAGEM DE DADOS (API Real + Mock)
    const title = data?.titulo || data?.title || 'Ativo Localizado';
    const price = data?.preco || data?.price;
    const location = data?.bairro || data?.location || 'Setor Prime';
    const mainImage = data?.imagensDestaque?.[0] || data?.image || 'https://images.unsplash.com/photo-1568605114967-8130f3a36994';

    const formattedPrice = typeof price === 'number' 
        ? price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 })
        : price || '---';

    return (
        <motion.div 
            whileHover={{ y: -4, scale: 1.02 }}
            className="flex gap-4 p-3 rounded-[1.8rem] border transition-all duration-300 group cursor-pointer"
            style={{ 
                backgroundColor: 'var(--bg-card)', 
                borderColor: 'var(--border-color)',
                boxShadow: '0 10px 25px -10px rgba(0,0,0,0.1)'
            }}
        >
            {/* 📸 MICRO VIEWPORT (STREET PREVIEW) */}
            <div className="w-20 h-20 rounded-2xl overflow-hidden bg-zinc-200 flex-shrink-0 relative">
                <img 
                    src={mainImage} 
                    alt={title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-125" 
                />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-transparent transition-colors" />
                
                {/* Badge de Verificação Sniper */}
                <div className="absolute bottom-1 right-1 bg-white/90 backdrop-blur-sm p-1 rounded-lg shadow-xl">
                    <FiCheck size={8} className="text-green-600" />
                </div>
            </div>

            {/* 📄 INTELLIGENCE BLOCK */}
            <div className="flex flex-col justify-center flex-1 min-w-0 space-y-1">
                {/* Social Proof HUD */}
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-1.5 text-[8px] font-black uppercase tracking-tighter" style={{ color: '#eab308' }}>
                        <FiStar fill="#eab308" size={10} /> 
                        <span className="text-auto opacity-60">4.9</span>
                        <span className="text-auto opacity-30">(22 REVIEWS)</span>
                    </div>
                    <FiNavigation size={10} className="text-auto opacity-20 group-hover:opacity-100 transition-opacity" style={{ color }} />
                </div>

                {/* Título com Limite de Caracteres */}
                <div className="text-[11px] font-black uppercase tracking-tighter text-auto truncate leading-tight group-hover:text-accent transition-colors"
                     style={{ color: 'var(--text-primary)' }}>
                    {title}
                </div>

                {/* Localização Stealth */}
                <div className="flex items-center gap-1 opacity-40">
                    <FiMapPin size={8} />
                    <span className="text-[8px] font-bold uppercase truncate">{location}</span>
                </div>

                {/* Preço em Destaque */}
                <div className="text-xs font-black tracking-tight"
                     style={{ color: color || 'var(--accent-color)' }}>
                    {formattedPrice}
                </div>
            </div>

            {/* Micro Indicador Lateral */}
            <div className="w-1.5 h-full bg-auto opacity-5 rounded-full" style={{ backgroundColor: color }} />
        </motion.div>
    );
}